// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b0-3";
export var contentContainer = "_b0-0";
export var editorContainer = "_b0-1";
export var quillInputForm = "_b0-2";
export var zoneDivider = "_b0-4";